module.exports = __webpack_public_path__ + "media/images/lb/740-c2402ce82fbd3e4511b6433466bcb353.svg";